import { PlanType, FoodType, SubscriptionFrequency } from '@calo/types';
import { PricingService } from '.';
import { MEALO_FOOD_TYPE_PRICING } from './constants';
class MealoPlanService {
    getFoodTypeForPlan(planType) {
        switch (planType) {
            case PlanType.skipDinner:
                return [FoodType.breakfast, FoodType.lunch, FoodType.snack];
            case PlanType.skipBreakfast:
                return [FoodType.dinner, FoodType.lunch, FoodType.snack];
            case PlanType.businessLunch:
                return [FoodType.lunch, FoodType.snack];
            default:
                return [FoodType.breakfast, FoodType.dinner, FoodType.lunch, FoodType.snack];
        }
    }
    getFoodTypePrice(foodType, dietType, currency) {
        const fta = (Array.isArray(foodType) ? foodType : [foodType]).reduce((res, ft) => {
            if (!res[ft]) {
                res[ft] = 0;
            }
            res[ft]++;
            return res;
        }, {});
        const breakfastPrice = (fta[FoodType.breakfast] || 0) * MEALO_FOOD_TYPE_PRICING[dietType][FoodType.breakfast][currency];
        const lunchAndDinnerPrice = ((fta[FoodType.dinner] || 0) + (fta[FoodType.lunch] || 0)) * MEALO_FOOD_TYPE_PRICING[dietType][FoodType.dinner][currency];
        const snackPrice = (fta[FoodType.snack] || 0) * MEALO_FOOD_TYPE_PRICING[dietType][FoodType.snack][currency];
        return breakfastPrice + lunchAndDinnerPrice + snackPrice;
    }
    getPlan({ planType, foodType, extras = [], dietType, frequency, currency }) {
        let pricePerDay = this.getFoodTypePrice([...foodType, ...extras], dietType, currency);
        if (frequency === SubscriptionFrequency.weekly) {
            pricePerDay += 1;
        }
        else if (frequency === SubscriptionFrequency.monthly && planType === PlanType.businessLunch) {
            pricePerDay += 0.5;
        }
        return {
            id: planType,
            frequency,
            extras,
            foodType,
            pricePerDay,
            dietType
        };
    }
    getPlanPrice(plan, deliveryDays, currency) {
        const price = (plan.frequency === SubscriptionFrequency.weekly ? 1 : 4) * deliveryDays.length * plan.pricePerDay;
        return PricingService.roundAmount(price, currency);
    }
}
export default MealoPlanService;
